import { Loader } from "@googlemaps/js-api-loader";
import { GridAlgorithm, MarkerClusterer } from "@googlemaps/markerclusterer";
import "js-info-bubble";
import GoogleMap from "../utils/map";

const portfolio = {
    element: $('#google-map'),
    init: function () {
        portfolio.map();
    },

    map: function () {
        const loader = new Loader({
            apiKey: gmap_api_key,
            version: "weekly",
        });
        loader.load().then((google) => {
            portfolio.render();
        });
    },

    render: function () {

        if (portfolio.element.length) {
            const google = window.google;
            const map = new google.maps.Map(portfolio.element[0], {
                zoom: 30,
                center: { lat: 56.960862, lng: 24.105513 },
                mapTypeControl: false,
                fullscreenControl: true,
                streetViewControl: false,
                zoomControl: true,
                styles: [{ "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] }, {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }]
                }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }]
                }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }]
                }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [{ "color": "#dedede" }, { "lightness": 21 }]
                }, { "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, {
                    "elementType": "labels.text.fill",
                    "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }]
                }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }]
                }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }]
                }],
            });

            $.ajax({
                url: ajaxurl,
                type: 'POST',
                data: {
                    action: 'get_social_coordinates',

                },
                beforeSend: function (xhr) {

                },
                success: function (data) {
                    // console.log(data);
                    var i;
                    var parsedData = JSON.parse(data);

                    var bounds = new google.maps.LatLngBounds();

                    // Add some markers to the map.
                    // Note: The code uses the JavaScript Array.prototype.map() method to
                    // create an array of markers based on a given "locations" array.
                    // The map() method here has nothing to do with the Google Maps API.
                    var activeBubble = -1;
                    var markers = parsedData.map(function (location, i) {
                        var marker = new google.maps.Marker({
                            position: location,
                            optimized: false,
                            icon: $('#google-map').data('pin'),
                        });

                        bounds.extend(location);

                        var offer = $('.offer[data-id="' + parsedData[i]['id'] + '"]');
                        var content = $('<div><div class="google__content">' +
                            '<div class="portfolio-item">' +
                            ' <div class="portfolio-item__image">' +
                            '<div class="portfolio-item__image__inner"><img src="' + parsedData[i]['image'] + '" alt=""></div>' +
                            '</div>' +
                            '<div class="portfolio-item__text">' +
                            '<h2 class="portfolio-item__title">' + parsedData[i]['title'] + '</h2>' +
                            '</div>' +
                            '</div></div></div>');
                        $('.portfolio-item__image__inner img, .offer__title', content).wrap('<a href="' + parsedData[i]['permalink'] + '"></a>')
                        $('.portfolio-item__text', content).append('<a href="' + parsedData[i]['permalink'] + '" class="portfolio-item__more button">' + $('#google-map').data('view') + '</a>')
                        var infoBubble = new window.InfoBubble({
                            content: content.html(),
                            arrowSize: 0,
                            arrowPosition: 0,
                            arrowStyle: 0,
                            shadowStyle: 0,
                            padding: 0,
                            borderRadius: 0,
                            borderWidth: 0,
                            backgroundClassName: 'google__popup',
                            backgroundColor: 'transparent',
                            maxWidth: 390,
                            minWidth: 390,
                            closeSrc: portfolio.element.data('close'),
                        });

                        marker.addListener('click', function () {
                            if (activeBubble != -1) activeBubble.close();
                            activeBubble = infoBubble;
                            infoBubble.open(map, marker);
                        });

                        i++;

                        return marker;
                    });

                    map.fitBounds(bounds);

                    // Add a marker clusterer to manage the markers.
                    new MarkerClusterer({
                        map,
                        markers,
                        renderer: GoogleMap.rendeder,
                        algorithm: new GridAlgorithm({
                            gridSize: 40,
                        }),
                    });
                }
            });
        }
    },
}

export default portfolio;
